'use client';

import type { SchoolDistrict } from '@/app/data/school-districts';

import { NON_PUBLIC_DISTRICTS } from './flow';

/**
 * The school districts for a ZIP code, from the same service as the standard form (a lookup that
 * times out or fails leaves just Private School and Other, as the form does). The service module is
 * loaded on demand: it pulls in the district data.
 */
export const fetchDistrictsForZip = async (zip: string): Promise<SchoolDistrict[]> => {
  try {
    const { schoolDistrictService } = await import('@/app/services/school-district.service');
    const districts = await schoolDistrictService.getDistrictsForZip(zip);
    return districts.length ? districts : [...NON_PUBLIC_DISTRICTS];
  } catch {
    return [...NON_PUBLIC_DISTRICTS];
  }
};
